export default {
  title: '总览',
  personalTitle: '个性化仪表盘',
  tab: '总览',
  btn: {
    my: '我的',
    all: '所有',
    jobs: '职位',
    open: '开放',
    applications: '申请',
    more: '更多',
    save: '保存',
    cancel: '取消',
    personalize: '个性化仪表板',
    timeRange: {
      DAY_7: '最近7天',
      DAY_30: '最近30天',
      DAY_180: '最近180天'
    }
  },
  message: {
    jobsInfo: {
      jobsOpen: '开放职位',
      jobsScreening: '筛选中职位',
      interviewing: '面试中职位',
      jobsHired: '雇佣职位',
      onHold: '暂停职位',
      addJobs: '添加职位'
    },
    jobAgingList: {
      nameOne: '<20 天',
      nameTwo: '20-40 天',
      nameThree: '40-60 天',
      nameFour: '61+ 天'
    },
    addJobs: '添加职位',
    hasNoPermission: '您没有权限进行相关操作，请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    jobCountNoEnough: '您不能创建更多职位，请联系你的AJINGA管理员或者客户成功顾问获取支持。',
    addApplication: '添加申请',
    interviewStatus: {
      finished: '已评估',
      scheduled: '已预约',
      pending: '待评估',
      canceled: '已被取消'
    },
    notification: {
      noMessage: '当前无系统消息'
    }
  },
  containerTitle: {
    jobs: '职位',
    applications: '申请',
    interviews: '面试',
    channels: '渠道',
    talentPool: '人才库',
    notification: '新通知',
    jobAging: '职位变动',
    application: {
      ALL: '申请总数',
      NEW: '新增申请数',
      UNREAD: '未读',
      SCREENING: '筛选中申请数',
      INTERVIEWING: '面试中申请数',
      ONBOARDING: '入职中申请数',
      LEADS: '潜在求职者'
    },
    interview: {
      interview: '面试',
      recruiter: '招聘人员',
      managers: '招聘经理',
      status: '状态'
    },
    recruiterKpi: '招聘人员KPI仪表盘'
  },
  label: {
    channelName: {
      weChat: '微信',
      referral: '推荐',
      notPublic: '未公开'
    },
    showInMainView: '在主视图中显示',
    hideFromMainView: '在主视图中隐藏',
    showInRightView: '在右视图中显示',
    hideFromRightView: '在右视图中隐藏',
    interview: {
      candidateName: '求职者: ',
      interviewersName: '面试官: '
    },
    selectCompany: '选择公司',
    open: '开放',
    all: '所有'

  }
}
